const { styled } = require("@mui/material");

const Subsection = styled("div")({
    paddingTop: 16,
    paddingBottom: 16,
});

export default Subsection;
